import { useState } from "react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Loader2, Banknote, CheckCircle } from "lucide-react";

export default function PaymentModal({ booking, open, onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handlePay = async () => {
    setLoading(true);
    try {
      await api.post("/payments", {
        booking_id: booking.id,
        amount: booking.total_amount,
        method: "cash",
        phone_number: ""
      });
      setSuccess(true);
      setTimeout(() => { setSuccess(false); onSuccess?.(); onClose(); }, 1500);
    } catch (e) {
      alert(e.response?.data?.detail || "Erreur de paiement");
    } finally { setLoading(false); }
  };

  if (!booking) return null;

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-sm" data-testid="payment-modal">
        <DialogHeader>
          <DialogTitle className="text-[#0A2540]" style={{ fontFamily: 'Outfit' }}>Paiement</DialogTitle>
        </DialogHeader>
        {success ? (
          <div className="py-8 text-center">
            <CheckCircle className="w-12 h-12 text-[#3B82F6] mx-auto mb-3" />
            <p className="text-lg font-semibold text-[#0A2540]">Reservation enregistree !</p>
            <p className="text-sm text-[#64748B]">En attente de confirmation du chauffeur</p>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="bg-[#F8FAFC] rounded-lg p-4 border border-[#CBD5E1]">
              <div className="flex justify-between items-center">
                <span className="text-sm text-[#64748B]">Montant total</span>
                <span className="text-xl font-bold text-[#0A2540]" style={{ fontFamily: 'Outfit' }}>{booking.total_amount?.toLocaleString()} XAF</span>
              </div>
            </div>

            <div className="bg-white rounded-lg border-2 border-[#0A2540] p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-[#10B981]/10 flex items-center justify-center">
                  <Banknote className="w-5 h-5 text-[#10B981]" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#0A2540]">Paiement en especes</p>
                  <p className="text-xs text-[#64748B]">Payez directement au chauffeur</p>
                </div>
              </div>
            </div>

            <Button onClick={handlePay} disabled={loading} className="w-full bg-[#0A2540] text-white hover:bg-[#081b2e] font-semibold h-11" data-testid="confirm-cash-payment-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Banknote className="w-4 h-4 mr-2" />}
              Confirmer le paiement
            </Button>

            <p className="text-xs text-center text-[#64748B]">
              Le paiement sera valide par le chauffeur a la prise en charge
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
